module.exports = __webpack_public_path__ + "static/shar-symbol-DND3_FnP-8faf317391671137eddca1d2c83657e0.webp";